export const SITE = "tryantar.com";
export const SOCIAL_QUERY_KEY = ["me", "social"] as const;
export const MEMORY_QUERY_KEY = ["me", "memory"] as const;
export const LANGUAGE_QUERY_KEY = ["me", "language"] as const;
export const LANGUAGE_LABEL: Readonly<Record<string, string>> = { en: "English", hi: "Hindi" };
